import { useQuery } from '@apollo/client';
import { GET_CURRENT_CLIENT_DATA } from '@pass-frontend/common/data-access';
import { OhidSession } from '@pass-frontend/data-access/common/edge';

export const useCurrentClientData = () => {
  const { loading, error, data } = useQuery<{
    ohidSession: Pick<
      OhidSession,
      'isOhidSessionValid' | 'clientName' | 'clientEmail'
    >;
  }>(GET_CURRENT_CLIENT_DATA, {
    ssr: false, // SKIP ON SSR COMPLETELY
    fetchPolicy: 'cache-first',
  });

  const { ohidSession } = data || {};

  return {
    loading: loading || false,
    error: error || false,
    clientName: ohidSession?.clientName || undefined,
    isClientAuthenticated: ohidSession?.isOhidSessionValid || false,
  };
};
